/* global axios */
import ApiClient from './ApiClient';
import { requestConfig } from './lais/httpHelpers';

// Self-service do corretor sobre o próprio perfil público + perfis de setor.
// O backend é um singular resource (agent_public_profile), por isso a URL não
// recebe id. O endpoint `postable` lista os perfis onde o corretor pode
// publicar um imóvel a partir do fluxo "Criar".
class AgentPublicProfileAPI extends ApiClient {
  constructor() {
    super('agent_public_profile', { accountScoped: true });
  }

  // GET .../agent_public_profile/postable
  // => { profiles: [{ id, slug, displayName, sector, agentCode }] }
  postable() {
    return axios.get(`${this.url}/postable`, requestConfig());
  }
}

export default new AgentPublicProfileAPI();
